const WsColors = {
  TheBlues950: '#337ab7',
  TheBlues900: '#0e4273',
  TheBlues800: '#0e4273',
  TheBlues750: ' #0C66E4',
  TheBlues700: '#0F4F8A',
  TheBlues600: '#1268B9',
  TheBlues500: '#1374CD',
  TheBlues400: '#3F94DA',
  TheBlues300: '#81BAE9',
  TheBlues200: '#A1CCEF',
  TheBlues100: '#D0E5F7',
  TheBlues50: '#EAF3FB',
  TheBlues75: '#DDECF9',
  TheBlues25: '#FAFAFC',
  TertiaryShades900: '#484D6D',
  TertiaryShades800: '#616893',
  TertiaryShades700: '#6F75A0',
  TertiaryShades600: '#7E84AA',
  TertiaryShades500: '#A0A4C0',
  TertiaryShades400: '#A9ADC6',
  TertiaryShades300: '#CED0DF',
  TertiaryShades200: '#DDDEE8',
  TertiaryShades100: '#EAEAF1',
  TertiaryShades50: '#F6F6F9',
  Green600: '#15803d',
  Green500: '#16a34a',
  Green400: '#4ade80',
  Green300: '#86efac',
  Green200: '#bbf7d0',
  Green100: '#dcfce7',
  Red600: '#dc2626',
  Red500: '#eb3030',
  Red400: '#ef4444',
  Red300: '#f87171',
  Red200: '#fca5a5',
  Red100: '#fecaca',
  Yellow700: '#a16207',
  Yellow600: '#ca8a04',
  Yellow500: '#eab308',
  Yellow400: '#facc15',
  Yellow300: '#fde047',
  Yellow200: '#fef08a',
  Yellow100: '#fef9c3',
  Neutral500: ' #77949A',
  Neutral300: ' #B3BCBE',
  BorderGrey: '#EAEAF1',
  GreyText: '#11151C',
  GreyText2: '#232833',
  GreyText3: '#34464E',
  Red: '#FF0000',
  GreyBlack: '#A0A4C0',
  White: '#FFFFFF',
  GenericRichBlack: '#11151C',
  YellowCompliment: '#AE7D00',
  None: '',
  BackGround: '#f5f5f5',
  IconBackGround: '#2c006e',
  TheBlue75: '#EFFCFD',
  BackGroundGreen: '#00BBA4',
  BackGroundYellow: '#E9B327',
  ForestGreen: '#108229',
  Pink: '#FF8DA1',
  GreyShade: '#f9f9f',
  LightGray: '#F0F2F3',
  Gray88: '#E0E0E0',
  YellowBg: '#FDF6B2',
  YellowBorder: '#E3A008',
  BackGroundRed: ' #FED8DD',
  DarkRed: '#C00000',
  BackGroundGrey: '#E5E7EB',
  BackGroundGreenLight: '#DCFCE7',
  TextGreen: '#14532D',
  Green800: '#065F46',
  BackGroundGreyLight: '#E8EDEE',
  IconLight: '#2E454B',
  TextLight: '#0D2E36',
  BackGroundBrandLight: '#67E8F933',
  BorderDivider: '#9EADB266',
  DefaultColor: '#000000',
  DefaultHeaderCellColor: '#f1f3f5',
  LinkOutline: ' #0891B2',
  LinkActive: ' #60A5FA',
  LinkVisited: ' #C026D3',
  ToolbarColor: '#ccc',
  SkyBlueTint: '#DBEAFE',
  TEXTBLUE: '#1E3A8A',
  INFORMATION800: '#1E40AF',
  TEXT: '#051A20',
  NEUTRAL_100: '#E8EDEE',
  white_shadow: '#FFFFFF80',
  background_grey_shadow: '#E8EDEE66',
  background_white_shadow: '#FFFFFF',
  LIGHT_BLUE: '#E3F2FD',
  PALE_GREEN: '#E8F5E8',
  SOFT_LAVENDER: '#F3E5F5',
  NewPrimary: '#2566EB',
  NewDarkBlue: '#1E293B',
  NewTextSec: '#64748B',
  NewTextMuted: '#94A3B8',
  NewBorder: '#E2E8F0',
  NewToolbarBorder: '#0000001F',
  NewBg: '#F8FAFC',
  AppLayoutBg: '#EBEEF3',
  AppLayoutTopBarShadowSoft: '#0000000A',
  AppLayoutTopBarShadowElevated: '#00000014',
  AppLayoutTopBarBorder: '#0000000F',
  SidebarDarkNavy: '#051729',
  SidebarIconMuted: '#FFFFFFB8',
  SidebarIconHover: '#FFFFFFF2',
  SidebarHoverBg: '#FFFFFF1F',
  HelperText: '#333333',

  // Standard swatch palette — grayscale row
  SwatchBlack: '#000000',
  SwatchGray800: '#434343',
  SwatchGray600: '#666666',
  SwatchGray500: '#999999',
  SwatchGray400: '#b7b7b7',
  SwatchGray300: '#cccccc',
  SwatchGray200: '#d9d9d9',
  SwatchGray100: '#efefef',
  SwatchGray50: '#f3f3f3',
  SwatchWhite: '#ffffff',

  // Red hue family
  SwatchRedVivid: '#980000',
  SwatchRedPastel: '#e6b8af',
  SwatchRedSoft: '#dd7e6b',
  SwatchRedMedium: '#cc4125',
  SwatchRedRich: '#a61c00',
  SwatchRedDeep: '#85200c',
  SwatchRedDarkest: '#5b0f00',

  // Coral hue family
  SwatchCoralVivid: '#ff0000',
  SwatchCoralPastel: '#f4cccc',
  SwatchCoralSoft: '#ea9999',
  SwatchCoralMedium: '#e06666',
  SwatchCoralRich: '#cc0000',
  SwatchCoralDeep: '#990000',
  SwatchCoralDarkest: '#660000',

  // Orange hue family
  SwatchOrangeVivid: '#ff9900',
  SwatchOrangePastel: '#fce5cd',
  SwatchOrangeSoft: '#f9cb9c',
  SwatchOrangeMedium: '#f6b26b',
  SwatchOrangeRich: '#e69138',
  SwatchOrangeDeep: '#b45f06',
  SwatchOrangeDarkest: '#783f04',

  // Yellow hue family
  SwatchYellowVivid: '#ffff00',
  SwatchYellowPastel: '#fff2cc',
  SwatchYellowSoft: '#ffe599',
  SwatchYellowMedium: '#ffd966',
  SwatchYellowRich: '#f1c232',
  SwatchYellowDeep: '#bf9000',
  SwatchYellowDarkest: '#7f6000',

  // Green hue family
  SwatchGreenVivid: '#00ff00',
  SwatchGreenPastel: '#d9ead3',
  SwatchGreenSoft: '#b6d7a8',
  SwatchGreenMedium: '#93c47d',
  SwatchGreenRich: '#6aa84f',
  SwatchGreenDeep: '#38761d',
  SwatchGreenDarkest: '#274e13',

  // Teal hue family
  SwatchTealVivid: '#00ffff',
  SwatchTealPastel: '#d0e0e3',
  SwatchTealSoft: '#a2c4c9',
  SwatchTealMedium: '#76a5af',
  SwatchTealRich: '#45818e',
  SwatchTealDeep: '#134f5c',
  SwatchTealDarkest: '#0c343d',

  // Blue hue family
  SwatchBlueVivid: '#4a86e8',
  SwatchBluePastel: '#c9daf8',
  SwatchBlueSoft: '#a4c2f4',
  SwatchBlueMedium: '#6d9eeb',
  SwatchBlueRich: '#3c78d8',
  SwatchBlueDeep: '#1155cc',
  SwatchBlueDarkest: '#1c4587',

  // Indigo hue family
  SwatchIndigoVivid: '#0000ff',
  SwatchIndigoPastel: '#cfe2f3',
  SwatchIndigoSoft: '#9fc5e8',
  SwatchIndigoMedium: '#6fa8dc',
  SwatchIndigoRich: '#3d85c6',
  SwatchIndigoDeep: '#0b5394',
  SwatchIndigoDarkest: '#073763',

  // Purple hue family
  SwatchPurpleVivid: '#9900ff',
  SwatchPurplePastel: '#d9d2e9',
  SwatchPurpleSoft: '#b4a7d6',
  SwatchPurpleMedium: '#8e7cc3',
  SwatchPurpleRich: '#674ea7',
  SwatchPurpleDeep: '#351c75',
  SwatchPurpleDarkest: '#20124d',

  // Magenta hue family
  SwatchMagentaVivid: '#ff00ff',
  SwatchMagentaPastel: '#ead1dc',
  SwatchMagentaSoft: '#d5a6bd',
  SwatchMagentaMedium: '#c27ba0',
  SwatchMagentaRich: '#a64d79',
  SwatchMagentaDeep: '#741b47',
  SwatchMagentaDarkest: '#4c1130',
};

export const SWATCH_PALETTE: readonly (readonly string[])[] = [
  [
    WsColors.SwatchBlack,
    WsColors.SwatchGray800,
    WsColors.SwatchGray600,
    WsColors.SwatchGray500,
    WsColors.SwatchGray400,
    WsColors.SwatchGray300,
    WsColors.SwatchGray200,
    WsColors.SwatchGray100,
    WsColors.SwatchGray50,
    WsColors.SwatchWhite,
  ],
  [
    WsColors.SwatchRedVivid,
    WsColors.SwatchCoralVivid,
    WsColors.SwatchOrangeVivid,
    WsColors.SwatchYellowVivid,
    WsColors.SwatchGreenVivid,
    WsColors.SwatchTealVivid,
    WsColors.SwatchBlueVivid,
    WsColors.SwatchIndigoVivid,
    WsColors.SwatchPurpleVivid,
    WsColors.SwatchMagentaVivid,
  ],
  [
    WsColors.SwatchRedPastel,
    WsColors.SwatchCoralPastel,
    WsColors.SwatchOrangePastel,
    WsColors.SwatchYellowPastel,
    WsColors.SwatchGreenPastel,
    WsColors.SwatchTealPastel,
    WsColors.SwatchBluePastel,
    WsColors.SwatchIndigoPastel,
    WsColors.SwatchPurplePastel,
    WsColors.SwatchMagentaPastel,
  ],
  [
    WsColors.SwatchRedSoft,
    WsColors.SwatchCoralSoft,
    WsColors.SwatchOrangeSoft,
    WsColors.SwatchYellowSoft,
    WsColors.SwatchGreenSoft,
    WsColors.SwatchTealSoft,
    WsColors.SwatchBlueSoft,
    WsColors.SwatchIndigoSoft,
    WsColors.SwatchPurpleSoft,
    WsColors.SwatchMagentaSoft,
  ],
  [
    WsColors.SwatchRedMedium,
    WsColors.SwatchCoralMedium,
    WsColors.SwatchOrangeMedium,
    WsColors.SwatchYellowMedium,
    WsColors.SwatchGreenMedium,
    WsColors.SwatchTealMedium,
    WsColors.SwatchBlueMedium,
    WsColors.SwatchIndigoMedium,
    WsColors.SwatchPurpleMedium,
    WsColors.SwatchMagentaMedium,
  ],
  [
    WsColors.SwatchRedRich,
    WsColors.SwatchCoralRich,
    WsColors.SwatchOrangeRich,
    WsColors.SwatchYellowRich,
    WsColors.SwatchGreenRich,
    WsColors.SwatchTealRich,
    WsColors.SwatchBlueRich,
    WsColors.SwatchIndigoRich,
    WsColors.SwatchPurpleRich,
    WsColors.SwatchMagentaRich,
  ],
  [
    WsColors.SwatchRedDeep,
    WsColors.SwatchCoralDeep,
    WsColors.SwatchOrangeDeep,
    WsColors.SwatchYellowDeep,
    WsColors.SwatchGreenDeep,
    WsColors.SwatchTealDeep,
    WsColors.SwatchBlueDeep,
    WsColors.SwatchIndigoDeep,
    WsColors.SwatchPurpleDeep,
    WsColors.SwatchMagentaDeep,
  ],
  [
    WsColors.SwatchRedDarkest,
    WsColors.SwatchCoralDarkest,
    WsColors.SwatchOrangeDarkest,
    WsColors.SwatchYellowDarkest,
    WsColors.SwatchGreenDarkest,
    WsColors.SwatchTealDarkest,
    WsColors.SwatchBlueDarkest,
    WsColors.SwatchIndigoDarkest,
    WsColors.SwatchPurpleDarkest,
    WsColors.SwatchMagentaDarkest,
  ],
];

export default WsColors;
